import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import LanguageManager from './LanguageManager';

class LanguageStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.LANGUAGE_STORE_FETCH:
        LanguageManager.fetch();
        return state;

      case ActionTypes.LANGUAGE_STORE_FETCH_COMPLETED:
        return action.languages;

      default:
        return state;
    }
  }
}

export default new LanguageStore();
